import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../services/auth/auth.service';
import { UserService } from '../services/user.service';
import { SpinnerService } from '../services/spinner';
import { IncludesComponent } from '../includes/includes.component';
import { VisionService } from '../services/vision.service';
import { CriteriaService } from '../services/criteria.service';
import { JobService } from '../services/job.service';
import { VisionModel } from '../models/vision.model';
import { SurveyDetails } from '../models/dto/survey';
import { SurveyTypes } from '../models/surveytypes';
import { CriteriaDetails } from '../models/dto/criteria';

@Component({
    selector: 'app-home-user',
    templateUrl: './home_user.component.html',
    styleUrls: ['./home_user.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HomeUserComponent implements OnInit {
    visionTypeSelected: number;
    user_data: any;
    modalReference: any; // modal variable
    closeResult: string; // modal variable
    email: string;
    curreySurvey: any;
    visionId: string;
    selectedModifyVision = 0;
    allVisionsAnswers: Array<any> = [];
    enableModify = false;
    finishedDelete = false;
    finishDeletePhrase = "Êtes-vous sûr de supprimer vision de ";
    userSurveys: Array<SurveyDetails>;
    selected_vision = 0;
    selected_vision_title = '';
    visionData: SurveyDetails;
    vision1: SurveyDetails; vision2: SurveyDetails; vision3: SurveyDetails; vision4: SurveyDetails;
    criteriasTitles1: string; criteriasTitles2: string; criteriasTitles3: string; criteriasTitles4: string;
    userHomeCriterias1: Array<CriteriaDetails>; userHomeCriterias2: Array<CriteriaDetails>; userHomeCriterias3: Array<CriteriaDetails>;
    userHomeCriterias4: Array<CriteriaDetails>;
    vision_selected1 = false; vision_selected2 = false; vision_selected3 = false; vision_selected4 = false;

    constructor(private visionService: VisionService, private visionModel: VisionModel, private surveyTypes: SurveyTypes,
        private modalService: NgbModal, private spinnerService: SpinnerService, private jobService: JobService,
        private criteriaService: CriteriaService) {

        const vision_title = localStorage.getItem('vision_title');
        this.email = localStorage.getItem('email');
        this.visionTypeSelected = this.surveyTypes.getTitleId(vision_title);  // selected vision
        this.visionService.getUserVisionsCriterias(this.email).subscribe(result => {
            this.user_data = result.User;
            this.userSurveys = this.user_data.surveys;
            this.pushSurveysCriterias();
        });
        this.getSurveyAnswers();
    }

    ngOnInit() { }

    getSurveys() {
        this.visionService.getUserVisionsCriterias(this.email).subscribe(result => {
            this.user_data = result.User;
            this.userSurveys = this.user_data.surveys;
            this.pushSurveysCriterias();
        });
    }

    assignCriterias(visionCriterias: Array<CriteriaDetails>, critieraNumber: number) {
        let critieraTitle = '';
        let i = 0;
        visionCriterias.forEach(criteria => {
            critieraTitle += criteria.title;
            if (i < visionCriterias.length - 1) { critieraTitle += ', '; }
            i++;
        });
        if (critieraNumber === 1) {
            this.criteriasTitles1 = critieraTitle;
        } else if (critieraNumber === 2) {
            this.criteriasTitles2 = critieraTitle;
        } else if (critieraNumber === 3) {
            this.criteriasTitles3 = critieraTitle;
        } else if (critieraNumber === 4) {
            this.criteriasTitles4 = critieraTitle;
        }
    }

    pushSurveysCriterias() {
        let i = 1;
        this.userSurveys.forEach(survey => {
            if (survey.criterias.length > 0) {
                if (this.surveyTypes.getTitleId(survey.title) === 1) {
                    this.vision1 = survey;
                    this.assignCriterias(survey.criterias, 1);
                }
                if (this.surveyTypes.getTitleId(survey.title) === 2) {
                    this.vision2 = survey;
                    this.assignCriterias(survey.criterias, 2);
                }
                if (this.surveyTypes.getTitleId(survey.title) === 3) {
                    this.vision3 = survey;
                    this.assignCriterias(survey.criterias, 3);
                }
                if (this.surveyTypes.getTitleId(survey.title) === 4) {
                    this.vision4 = survey;
                    this.assignCriterias(survey.criterias, 4);
                }
            }
            i++;
        });
    }

    checkSelectedVisions() {
        if (this.userSurveys) {
            let selectedVision = this.surveyTypes.getTitle(1);
            let isExist = this.userSurveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected1 = true;
            }
            selectedVision = this.surveyTypes.getTitle(2);
            isExist = this.userSurveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected2 = true;
            }
            selectedVision = this.surveyTypes.getTitle(3);
            isExist = this.userSurveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected3 = true;
            }
            selectedVision = this.surveyTypes.getTitle(4);
            isExist = this.userSurveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected4 = true;
            }
        }

    }
    selectRadio(value) {
        if (value === 1 && this.vision_selected1) {
            this.enableModify = true;
        } else if (value === 2 && this.vision_selected2) {
            this.enableModify = true;
        } else if (value === 3 && this.vision_selected3) {
            this.enableModify = true;
        } else if (value === 4 && this.vision_selected4) {
            this.enableModify = true;
        } else {
            this.enableModify = false;
        }
        this.selectedModifyVision = value;
    }
    open(content) {
        this.modalService.open(content).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    openConfirmDeleteVisionModal(content) {
        // this.modalService.open(content);
        this.modalReference = this.modalService.open(content, { windowClass: 'hm-usr-confirmDelete' });
    }
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    select_to_delete(value) {
        this.selected_vision = value;
        this.selected_vision_title = this.surveyTypes.getTitle(this.selected_vision);
    }
    clearVision(selected_vision) {
        if (selected_vision === 1) {
            this.vision1 = null;
        } else if (selected_vision === 2) {
            this.vision2 = null;
        } else if (selected_vision === 3) {
            this.vision3 = null;
        } else if (selected_vision === 4) {
            this.vision4 = null;
        }
    }
    closeDeleteConfrim(content) {
        this.modalReference.close();
    }
    deleteVisionInUserHome(selected_vision) {
        this.spinnerService.show();
        const answersIds: Array<string> = [];
        const title = this.surveyTypes.getTitle(selected_vision);
        const survey = this.userSurveys.filter(x => x.title === title)[0];
        const vision_id = survey.id;
        const criteriasIds: Array<string> = [];
        const optionsIds: Array<string> = [];
        const criterias = survey.criterias;
        criterias.forEach(criteria => {
            criteriasIds.push(criteria.id);
            const options = criteria.options;
            options.forEach(option => {
                optionsIds.push(option.id);
            });
        });
        let index = 0;
        if (optionsIds.length > 0) {
            optionsIds.forEach(option => {
                const allAnswers = this.allVisionsAnswers.filter(x => x.surveyId === vision_id);
                allAnswers.forEach(answer => {
                    index++;
                    const isExist = answersIds.filter(x => x === answer.id)[0];
                    if (!isExist) {
                        answersIds.push(answer.id);
                    }
                });
                if (index >= allAnswers.length) {
                    // delete vision
                    let allMutations = `mutation {`;
                    if (optionsIds.length > 0) {
                        allMutations += this.criteriaService.buildDeleteOptions2(optionsIds);
                        allMutations += this.criteriaService.buildDeleteAnswers2(answersIds);
                    }
                    allMutations += this.criteriaService.buildDeleteCriterias2(criteriasIds);
                    allMutations += this.visionService.buildDeleteVision(vision_id);
                    allMutations += ' }';

                    this.jobService.mutateEditOffer(allMutations).subscribe(resp2 => {
                        // finished
                        this.clearVision(selected_vision);
                        this.spinnerService.hide();
                        document.getElementById('closeDeleteConfirm').click();
                    });
                }
            });
        } else {
            // this.visionService.deleteVision(vision_id).subscribe(resp => {
            //     let allMutations = `mutation {`;
            //     allMutations += this.criteriaService.buildDeleteCriterias2(criteriasIds);
            //     allMutations += this.visionService.buildDeleteVision(vision_id);
            //     allMutations += ' }';
            //     this.jobService.mutateEditOffer(allMutations).subscribe(resp2 => {
            //         // finished
            //         this.clearVision(selected_vision);
            //         this.spinnerService.hide();
            //         document.getElementById('closeDeleteConfirm').click();
            //     });
            // });
        }
    }
    getSurveyAnswers() {
        this.jobService.getUserSurveyAnswers(this.email).subscribe(data => {
            data.allUsers[0].surveys.forEach(survey => {
                const surveyId = survey.id;
                survey.offers.forEach(offer => {
                    offer.answers.forEach(answer => {
                        this.allVisionsAnswers.push({ surveyId: surveyId, answerId: answer.id });
                    });
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/home/home.user.component.ts